//#region |********\  Imports  ######################################
import React, { useState, useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import Nav from './nav.js';
import PassPhrase from './00_password/pass_phrase';
import Hero from './01_hero/hero';
import Chests from './04_chests/chests';
import Trails from './06_trails/trails';
import Congrats from './07_congrats/congrats';
import LegalFooter from './legal_footer/legal_footer.js';
//#endregion |********///////////////////////////////////////////////////
//#region |********\  QUEST   #######################################
export default function Quest(props) {
  //# ||****\ VARS \\\\\\\\\\\\\\\\\\\\\\\\\\\\\
  //# |||**\ hooks -------
  const name = useFormInput('')
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentOpenedChests, setCurrentOpenedChests] = useState(0);
  const [currentChest, setCurrentChest] = useState(0);
  const [chestsLoading, setChestsLoading] = useState(true);
  const [trailsLoading, setTrailsLoading] = useState(true);
  useEffect(() => {
    if (props.passwordEntered === true && currentSlide == 0) {
    goToSlide(1);
    }
    return () => {};
  });
  let legal_footer = <LegalFooter
  consentOpen={props.consentOpen}
  setConsentOpen={props.setConsentOpen}
  />;
  let nav = <Nav
    settings={props.settings}
    nextSlide={incrementSlide}
    currentSlide={currentSlide}
    goToSlide={goToSlide}
  />;
  let askPassword = <PassPhrase
  nextSlide={incrementSlide}
  currentSlide={currentSlide}
  goToSlide={goToSlide}
  name={name}
  passwordEntered={props.passwordEntered}
  setPasswordEntered={props.setPasswordEntered}
  />;
  let hero = <Hero
    theme={props.settings.theme}
    logo={props.settings.logo_url}
    heroText={props.settings.hero_text}
    nextSlide={incrementSlide}
    goToSlide={goToSlide}
    currentSlide={currentSlide}
  />;

  let chests = <Chests
    chests={props.trailData.chests}
    settings={props.settings}
    setSettings={props.setSettings}
    currentChest={props.settings.chests[currentChest]}
    setChest={setChest}
    currentSlide={currentSlide}
    chestsLoading={chestsLoading}
    trailData={props.trailData}
    setTrailData={props.setTrailData}
  />;
  let trails = <Trails
    primaryColor={props.settings.primary_color}
    trailsLoading={trailsLoading}
    currentSlide={currentSlide}
    trailData={props.trailData.chests[currentChest].trails}
    certData={props.trailData.chests[currentChest].certs}
    currentChest={props.trailData.chests[currentChest]}
    nextSlide={incrementSlide}
    goToSlide={goToSlide}
    setChestsLoading={setChestsLoading}
    trackEvent={props.trackEvent}
  />;
  let congrats = <Congrats
    primaryColor={props.settings.primary_color}
    settings={props.settings}
    chestTitle={props.trailData.chests[currentChest].title}
    currentSlide={currentSlide}
    goToSlide={goToSlide}
  />;


  //# |||**/--------------
  //# ||****/////////////////////////////////////
  //# ||****\ FUNCTIONS  \\\\\\\\\\\\\\\\\\\\\\\

  function setChest(i) {
    var tempCompany = props.trailData;
    tempCompany.chests[i].isOpened = true;
    // props.setSettings(tempCompany);
    props.setTrailData(tempCompany)
    setCurrentChest(i);
    props.trackEvent('Picked chest: ' + tempCompany.chests[i].title);
    if (currentOpenedChests < 1) {
      setCurrentOpenedChests(currentOpenedChests + 1);
      incrementSlide();
    } else {
      setTrailsLoading(true);
      setCurrentSlide(3);
      scroll.scrollToBottom();
      setTimeout(function () {
        setTrailsLoading(false);
      }, 1000);
    }
  }

  function incrementSlide() {
    props.trackEvent('Went to slide ' + currentSlide);
    if (currentSlide === 1) {
      scroll.scrollToBottom();
      setTimeout(function () {
        setChestsLoading(false);
      }, 500);
    } else if (currentSlide === 2) {
      scroll.scrollToBottom();
      setTimeout(function () {
        setTrailsLoading(false);
      }, 500);

    } else {
      scroll.scrollToBottom();
    }
    setCurrentSlide(currentSlide + 1);
    props.setPasswordEntered(true);
  }
  function goToSlide(e) {
    setChestsLoading(true);
    setTrailsLoading(true);
    if (e === 1) {
      scroll.scrollToBottom();
      setTimeout(function () {
        // setChestsLoading(false);
        // setTrailsLoading(false);
      }, 500);
    } else if (e === 2) {
      scroll.scrollToBottom();
      setTimeout(function () {
        setChestsLoading(false);
        setTrailsLoading(false);
      }, 1000);

    } else {
      setTimeout(function () {
        scroll.scrollToBottom();
      }, 0);
    }
    setCurrentSlide(e);

  }

  //# ||****////////////////////////////////
  //# ||****\ RENDER \\\\\\\\\\\\\\\\\\\\\\\\\\\
  return (
    <div className="quest">
      {nav}
      {askPassword}
      {hero}
      {chests}
      {trails} 
      {congrats}
      {legal_footer}
    </div>
  );
  //# ||****///////////////////////////////////////////////////
}
//#endregion |********/#################################################
//#region |********\  Hook Functions (useFormInput)#####################
function useFormInput(initialValue) {
  const [value, setValue] = useState(initialValue);
  function handleChange(e) {
    setValue(e.target.value)
  }
  return {
    value,
    onChange: handleChange
  };
}
//#endregion |********///////////////////////////////////////////////////